(function () {
  'use strict';

  // Torque cadence calculator
  // 18g per cup (filter and espresso both assumed 18g)
  // Freshness cap: a bag should ideally be finished within 28 days
  // Bags: 12oz = 340g, 2lb = 907g, 5lb = 2268g
  var GRAMS_PER_CUP = 18;
  var FRESH_CAP_DAYS = 28;

  var BAGS = [
    { id: '12oz', label: '12oz bag', grams: 340 },
    { id: '2lb', label: '2lb bag', grams: 907 },
    { id: '5lb', label: '5lb bag', grams: 2268 }
  ];

  // Subscribable cadences, in days
  var FREQS = [
    { label: 'every week', days: 7 },
    { label: 'every 2 weeks', days: 14 },
    { label: 'every 4 weeks', days: 28 },
    { label: 'every 6 weeks', days: 42 }
  ];

  var TorqueCadence = {
    init: function () {
      var roots = document.querySelectorAll('[data-torque-cadence]');
      if (!roots.length) { return; }
      for (var i = 0; i < roots.length; i++) {
        this.wire(roots[i]);
      }
    },

    wire: function (root) {
      var self = this;
      var people = root.querySelector('[data-tc-people]');
      var cups = root.querySelector('[data-tc-cups]');
      var out = root.querySelector('[data-tc-result]');
      if (!people || !cups || !out) { return; }

      function recompute() {
        var p = parseFloat(people.value);
        var c = parseFloat(cups.value);
        if (!p || !c || p < 1 || c <= 0) {
          out.innerHTML = '';
          return;
        }
        var rec = self.recommend(p, c);
        out.innerHTML = self.render(rec, p, c);
      }

      people.addEventListener('input', recompute);
      cups.addEventListener('input', recompute);
      people.addEventListener('change', recompute);
      cups.addEventListener('change', recompute);
    },

    recommend: function (people, cupsPerDay) {
      var dailyGrams = people * cupsPerDay * GRAMS_PER_CUP;
      var candidates = [];

      for (var b = 0; b < BAGS.length; b++) {
        var bag = BAGS[b];
        var daysToFinish = bag.grams / dailyGrams;

        // Bag empties too fast: shipping would be relentless. Skip.
        if (daysToFinish < 5) { continue; }
        // Past freshness window: only allow on the smallest bag (light drinkers).
        if (daysToFinish > FRESH_CAP_DAYS + 0.5 && bag.id !== '12oz') { continue; }

        // Pick the longest cadence that still arrives around when they run out.
        var chosen = null;
        for (var f = 0; f < FREQS.length; f++) {
          if (FREQS[f].days <= daysToFinish + 1.5) { chosen = FREQS[f]; }
        }
        if (chosen) {
          candidates.push({ bag: bag, freq: chosen, daysToFinish: daysToFinish });
        }
      }

      if (!candidates.length) {
        // Very light drinker: smallest bag, longest cadence, and we say so honestly.
        return {
          bag: BAGS[0],
          freq: FREQS[FREQS.length - 1],
          daysToFinish: BAGS[0].grams / dailyGrams,
          light: true
        };
      }

      // Fewest shipments wins: largest qualifying bag, then longest cadence.
      candidates.sort(function (a, b) {
        if (a.bag.grams !== b.bag.grams) { return a.bag.grams - b.bag.grams; }
        return a.freq.days - b.freq.days;
      });
      var pick = candidates[candidates.length - 1];
      pick.light = false;
      return pick;
    },

    render: function (rec, people, cupsPerDay) {
      var totalCupsDay = people * cupsPerDay;
      var weeklyCups = Math.round(totalCupsDay * 7);

      var headline = 'Looks like you are a <strong>' + rec.bag.label +
        ', ' + rec.freq.label + '</strong> household.';

      var math = people + (people === 1 ? ' person' : ' people') +
        ' &times; ' + cupsPerDay + (cupsPerDay === 1 ? ' cup' : ' cups') +
        ' a day is about ' + weeklyCups + ' cups a week. ' +
        'That keeps a ' + rec.bag.label + ' moving while it is still fresh.';

      var note;
      if (rec.light) {
        note = 'You drink it slow, and that is great. A 12oz every 6 weeks keeps a ' +
          'smaller bag in rotation so it never sits long enough to fade. ' +
          'Want it even slower? Skip a delivery anytime, right from your account.';
      } else {
        note = 'You can change your pace, skip a delivery, pause, or cancel anytime, ' +
          'all from your account in a click. Pick the lane you love and we will keep it coming.';
      }

      return '<p class="tc-headline">' + headline + '</p>' +
        '<p class="tc-math">' + math + '</p>' +
        '<p class="tc-note">' + note + '</p>';
    }
  };

  function self_trim(n) {
    return String(n);
  }

  window.TorqueCadence = TorqueCadence;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { TorqueCadence.init(); });
  } else {
    TorqueCadence.init();
  }
})();
